<template>
	<v-layout wrap>
		<v-flex xs12>
			<div class="wrapper-logo">
				<img :src="`${$S3}logo-mibodega-green.png`" alt="logo">
			</div>
		</v-flex>
		<v-flex xs12 md7>
			<div class="image-footer">
				<div class="footer-text">NUESTROS CANALES DE <br/> CONTACTO OFICIALES</div>
			</div>
		</v-flex>
		<v-flex xs12 md5 class="wrapper-info">
			<div class="footer-info">
				<p class="name-country">Perú</p>
				<div class="mb-3">
					<a
						href="https://goo.gl/maps/8vAGxHq1v49WAxj26" 
						class="mb-0 direction"
						target="_blank"
					>
						Lima
					</a>
					<p class="mb-0">+51 940 637 220</p>
					<p class="mb-0">Calle Independencia  106,  Piso 10</p>
					<p class="mb-0">Miraflores</p>
				</div>
			</div>
			<div>
				<a 
					href="https://www.facebook.com/Mi-bodega--107633674246248/?modal=admin_todo_tour"
					class="mr-3"
					target="_blank"
				>
					<img :src="`${$S3}facebook-logo.png`" alt="facebook" height="30px">
				</a>
				<a 
					href="https://www.instagram.com/mibodegape/"
					target="_blank"
				>
					<img :src="`${$S3}instagram-logo.png`" alt="instagram" height="30px">
				</a>
			</div>
		</v-flex>
		<v-flex xs12 class="footer-end">
			<p class="mb-0">Derechos reservados  <a href="https://www.makipos.la" target="_blank" class="link">makipos.la</a> | Desarrollado por apprunn</p>
		</v-flex>
	</v-layout>
</template>
<script>
export default {
	name: 'footer-pago',
};
</script>
<style lang="scss" scoped>
	.image-footer {
		background-image: url('https://mibodega.s3-sa-east-1.amazonaws.com/footer-pago.png');
		background-size: cover;
    background-position: top;
		height: 492px;
		padding-top: 30%;
		width: 100%;

		@media (max-width: 959px) {
			height: 252px;
			padding-top: 15%;
		}
	}

	.footer-text {
		background-color: map-get($colors, white);
		border-radius: 17px;
		color: map-get($colors, title-green);
		font-size: 20px;
		font-weight: map-get($weight, w900);
		margin: 0 auto;
		opacity: 0.65;
		padding: 33px;
		width: 372px;
	}

	.wrapper-logo {
		border-bottom: 4px solid map-get($colors, green-link);
		padding: 30px 6% 30px 0;
		text-align: right;

		@media (max-width: 959px) {
			text-align: center;
		}
	}

	.wrapper-info {
		padding: 10% 6% 0 0;
		text-align: right;
	}

	.footer-end {
		background: color(green-link);
		bottom: 0;
		color: color(white);
		font-family: font(lato-regular);
		font-size: size(medium16);
		font-weight: map-get($weight, w900);
		padding: 14px 0;
		text-align: center;
	}

	.footer-info {
		color: color(title-green);
		font-size: 16px;
	}

	.name-country {
		font-family: font(lato-regular);
		font-weight: 600;
		font-size: 24px;
	}

	.direction {
		color: color(title-green);
		text-decoration: none;
	}

	.link {
		color: map-get($colors, white);
		text-decoration: none;
	}

</style>


// WEBPACK FOOTER //
// src/components/pago/footer-pago.vue